import ThSortView from './ThSortView';

export default ThSortView;
